// removed by extract-text-webpack-plugin
module.exports = {"globalFooter":"index__globalFooter__23LWp","links":"index__links__1IOVF","copyright":"index__copyright__2c8dn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalFooter/index.less
// module id = 1112
// module chunks = 0